import moment from 'moment';
import { WorkCenterDay } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

// Incremental days are not editable in certain situations
export function isDayReadOnlyQuery(
  this: UiQueries,
  date: WorkCenterDay
): boolean {
  const today = moment();
  if (date.date.isSameOrAfter(today)) {
    return false;
  }

  return true;
}
